// extracted by mini-css-extract-plugin
export default {"account":"Account_account__LEXtR"};